import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ComponentSize, DEFAULT_COMPONENT_SIZE } from '@examdojo/core/model';
import { SingleSelectComponent } from '@examdojo/core/select';
import { QUESTION_STATUS_TO_LABEL, QUESTION_STATUSES } from '@examdojo/models/question';
import { QuestionStoreModel } from '../models';
@Component({
  selector: 'dojo-question-status-selector',
  template: `
    <dojo-single-select
      [formCtrl]="formCtrl()"
      [optionLabel]="'label'"
      [optionValue]="'value'"
      [options]="options"
      [label]="label()"
      [size]="size()"
    />
  `,
  imports: [SingleSelectComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestionStatusSelectorComponent {
  readonly formCtrl = input.required<FormControl<QuestionStoreModel['status']>>();
  readonly label = input<string>();
  readonly size = input<ComponentSize>(DEFAULT_COMPONENT_SIZE);

  readonly options = QUESTION_STATUSES.map((status) => ({
    value: status,
    label: QUESTION_STATUS_TO_LABEL[status],
  }));
}
